module.exports = __webpack_public_path__ + "static/media/SANOFI.1d927939.jpg";